module.exports = __webpack_public_path__ + "img/icon_white_baseball.b3642d48.svg";